import axios from 'axios';
import MultiUploader from './MultiUploader';

const API_URL_BASE = 'https://api.identity-registry.com/';

class DipClient {
	constructor(envKey) {
		this.baseUrl = API_URL_BASE + envKey;
		this.lastProgress = 0;
	}

	isAuthInfoValid() {
		// TODO
		if (this.token) return true;
		return false;
	}

	setAuthInfo(token, tokenExpire) {
		this.token = token;
		this.tokenExpire = tokenExpire;
	}

	async login(userName, password) {
		const url = this.baseUrl + '/authenticate';

		try {
			let response = await axios.post(url,
				{
					userName: userName,
					password: password,
				}
			);

			console.log('response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				this.userName = userName;
				this.token = response.data.authResult.token;
				this.tokenExpire = response.data.authResult.tokenExpire;
			}
		}
		catch (e) {
			console.log(e);
		}
	}

	async _checkIfResourcesReady(resolve, reject, resourceIds, progressCallback,
		maxTryLimit, tryLimit) {

		if (tryLimit <= 0) {
			reject("tryLimit reached");
			return;
		}

		let ready = true;
		let resources;

		try {
			resources = await this.getResources(resourceIds);
		}
		catch (e) {
			reject("getResources failed");
		}
		console.log('[DipClient] _checkIfResourcesReady / resources = ', resources);

		if (resources && resources.length > 0) {
			for (let i = 0; i < resources.length; i++) {
				if (resources[i].status !== 'READY') {
					ready = false;
					break;
				}
			}
		}

		if (progressCallback) {
			progressCallback(0.9 + 0.1 * (maxTryLimit - tryLimit) / maxTryLimit);
		}

		if (ready) {
			resolve(resources);
		}
		else {
			setTimeout(this._checkIfResourcesReady.bind(this), 1000,
				resolve, reject, resourceIds, progressCallback,
				maxTryLimit, tryLimit - 1);
		}
	}

	async waitUntilResourceReady(resourceIds, progressCallback, TRY_LIMIT = 100) {
		let dipClient = this;
		return new Promise((resolve, reject) => {
			try {
				dipClient._checkIfResourcesReady(resolve, reject,
					resourceIds, progressCallback, TRY_LIMIT, TRY_LIMIT);
			}
			catch (e) {
				reject();
			}
		});
	}

	async getResourceWithoutWait(resourceIds, progressCallback) {
		
		let resources;
		try {
			resources = await this.getResources(resourceIds);
		}
		catch (e) {
			console.log('getResourceWithoutWait fail / ', e);
			return undefined;
		}
		return resources;
	}

  async uploadFile(resourceType, file, resolutionLimit, progressCallback) {
    //return 'https://exaxdx.com/images/industry-1.jpg';

    let resourceName;
    if (resourceType === "image") {
      resourceName = "OnTagImage/" + file.name;
    } else if (resourceType === "video") {
      resourceName = "OnTagVideo/" + file.name;
    } else if (resourceType === "pdf") {
			resourceName = "OnTagPdf/" + file.name;	
		}

    let resourceParams = {
      resolutionLimit: resolutionLimit,
    };

    if (resourceType === "video") {
      resourceParams = {
        autoPrepare: true,
        startPos: undefined, // 파일 시작부터
        endPos: undefined, // 파일 끝까지
        captureConfig: {
          periodInSec: 1, // 1초 간격으로 capture
          n: 1, // 1장만 capture (default)
          quality: 100,
        },
        isWebcam: false,
        viewerHFlip: false,
      };
    }
		else if (resourceType === 'pdf') {
			resourceParams = {
				pdf: {
					generateImages: true
				}
			};
		}

    let resourceUrls = await this.addResources([
      {
        resourceName: resourceName,
        resourceType: resourceType,
        fileName: file.name,
        fileSize: file.size,
        resourceParams: resourceParams,
      },
    ]);

    console.log("uploadFile: file.name = " + file.name);
    console.log("uploadFile: resourceUrls = " + JSON.stringify(resourceUrls));
    if (progressCallback) {
      progressCallback(0.05);
    }

    if (resourceUrls && resourceUrls.length > 0) {
      let uploader = new MultiUploader([
        {
          url: resourceUrls[0].uploadUrl,
          file: file,
          contentType: resourceType,
          fileName: file.name,
          fileSize: file.size,
        },
      ]);

      let timer;
      if (progressCallback) {
        timer = setInterval(() => {
          progressCallback(0.05 + 0.8 * uploader.getProgress());
        }, 300);
      }

      let uploadResult = await uploader.upload();
      console.log("uploadFile: uploadResult = " + uploadResult);

      if (progressCallback) {
        clearInterval(timer);
        progressCallback(0.85);
      }

      let resources;
			// 비디오는 status ready를 바라보지 않고 업로딩만한다. 
			// edit / view 화면에서 getResources 로 상태를 바라본다.
      if (uploadResult && (resourceType === "video" || resourceType === 'pdf')) { 
        resources = await this.getResourceWithoutWait(
          resourceUrls.map((r) => r.resourceId),
          progressCallback
        );
      }
			else if (uploadResult)  {
        try {
          resources = await this.waitUntilResourceReady(
            resourceUrls.map((r) => r.resourceId),
            progressCallback
          );
        }
        catch (e) {
          console.log("uploadFile: failed to get resources");
        }
			}

      if (resources && resources.length > 0) {
        if (progressCallback) {
          progressCallback(1.0);
        }
        if (resources[0].transcodedUrl) {
          return {
            resourceId: resources[0].id,
            url: resources[0].transcodedUrl,
          };
				}
				else {
          return {
            resourceId: resources[0].id,
            url: resources[0].url,
          };
        }
      }
    }
    return undefined;
  }

	async uploadData(name, buf, progressCallback) {
		if (!buf || buf.length === 0) return false;

		const resourceType = 'misc';

		let resourceUrls = await this.addResources(
			[
				{
					resourceName: name,
					resourceType: resourceType,
					fileName: name,
					fileSize: buf.length,
				}
			]
		);

		console.log("uploadData: resourceUrls = " + JSON.stringify(resourceUrls));
		if (progressCallback) {
			progressCallback(0.05);
		}

		if (resourceUrls && resourceUrls.length > 0) {
			let cancelTokenSource = axios.CancelToken.source();
			let loaded = 0;

			let timer;
			if (progressCallback) {
				timer = setInterval(
					() => { progressCallback(0.05 + 0.9 * (loaded / buf.length)); },
					300
				);
			}

			let uploadResult;
			try {
				await axios({
					method: 'put',
					url: resourceUrls[0].uploadUrl,
					data: buf,
					maxContentLength: Infinity,
					maxBodyLength: Infinity,
					headers: {
						'Content-Type': 'application/octet-stream',
					},
					cancelToken: cancelTokenSource.token,
					onUploadProgress: progressEvent => {
						console.log("upload progress: loaded = " + progressEvent.loaded);
						loaded = progressEvent.loaded;
					}
				});
				uploadResult = true;
			}
			catch (e) {
				uploadResult = false;
			}
			console.log("uploadData: uploadResult = " + uploadResult);

			if (progressCallback) {
				clearInterval(timer);
				progressCallback(0.95);
			}

			if (uploadResult) {
				let resources = await this.getResources(resourceUrls.map(r => r.resourceId));
				if (resources && resources.length > 0) {
					return resources[0].url;
				}
			}

			if (progressCallback) {
				progressCallback(1.00);
			}
		}
		return undefined;
	}

	async downloadData(url, progressCallback) {
		let cancelTokenSource = axios.CancelToken.source();

		try {
			let response = await axios({
				method: 'get',
				url: url,
				cancelToken: cancelTokenSource.token,
				responseType: 'arraybuffer'
			});
			return Buffer.from(response.data).toString();
		}
		catch (e) {
			console.log("downloadData: exception = " + JSON.stringify(e));
		}
		return undefined;
	}

	async addResources(resources) {
		const url = this.baseUrl + '/add-resources';

		if (!this.token) return undefined;

		try {
			let response = await axios.post(url,
				{
					resources: resources
				},
				{
					headers: {
						Authorization: 'BEARER ' + this.token
					}
				}
			);
			console.log('response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				return response.data.resourceUrls;
			}
		}
		catch (e) {
			console.log(e);
		}
		return undefined;
	}

	// 여러개를 상태를 체크할수는 있게 api설계는 되어있는데 해당 결과에 대한 부분 처리는 논의가 안된 관계로 
	// 일단 1개만 쓴다고 가정하고 구현했다.
	async waitUntilResourceReady2(resourceIds, progressCallback, ) {
		const result = await this._resourceTimer(resourceIds, progressCallback);
		if (result) {
			return await this.getResources(resourceIds);	
		}
		return;	
		
	}

	_resourceTimer(resourceIds, progressCallback, ) {
		let dipClient = this;
		return new Promise((resolve, reject) => {
			try {
				dipClient._resourceCheckTimer(resolve, reject, resourceIds, progressCallback, 0);
			
			}
			catch (e) {
				console.log('_resourceCheckTimer fail');
			}
	
		});
	}

	//resolve, reject,resourceIds, progressCallback
	async _resourceCheckTimer(resolve, reject, resourceIds, onProgressCallback, timerCount, lastStatus)  {
		console.log('resourceCheckTimer / timerCount =', timerCount, ', lastProgress = ', this.lastProgress);
		var that = this;
		let result;
		try {
			if (timerCount <= 0) {
				result = await that._getResourceStatus(resourceIds);
				if (result === undefined) {
					console.log('getResourceStatus return undefined');
					that.lastProgress = 0;
					reject();
					return;
				}
			}
			else {
				result = lastStatus;
			}
		}
		catch(e) {
			console.log('resourceCheckTimer / exception / ', e);
			that.lastProgress = 0;
			reject();
			return;
		}

		if (result && result.length > 0) {
			if (result[0].status === 'READY') {
				console.log('[DipClient] resourceCheckTimer ready');
				onProgressCallback(100);	
				that.lastProgress = 0;
				resolve(true);
				return;
			}
		}
		const obj = result[0]; 
		if (timerCount <= 0) {
				// var expectingDuration: number = Math.round((obj.fileSize / DURATION_PER_SIZE) * 10) / 10;
			if (obj.prepProgress === undefined || typeof obj.prepProgress !== 'number') {
				setTimeout(
					that._resourceCheckTimer.bind(that), 3000, resolve, reject, resourceIds, onProgressCallback, 2, result);
				that.lastProgress = 0;
				return ;
			}
			const per = that._calcProgress(obj);	
			onProgressCallback(per);
			setTimeout(
				that._resourceCheckTimer.bind(that), 1000, resolve, reject, resourceIds, onProgressCallback, 4, result );
		}
		else {
			const per = that._calcProgress(obj);	
			onProgressCallback(per);
			setTimeout(
				that._resourceCheckTimer.bind(that), 1000, resolve, reject, resourceIds, onProgressCallback, timerCount-1, result );
		}
	}
	
	_calcProgress(obj) {
		var origin = 0;
		if (obj !== undefined && obj.prepProgress !== undefined && typeof obj.prepProgress === 'number') {
			origin = obj.prepProgress * 0.9; // 1인데 레디가 안되는 경우가 있다;;
		}
		else {
			origin = this.lastProgress;
		}
		console.log('_calcProgress/ obj.prepProgress = ', obj.prepProgress);
		const zeroBasePercent = Math.random() * (1.0) + 0.4; // 0일때 (아마도 preparing) 0.4~1.4 랜덤 
		const perPro = Math.random() * (2.0) + 0.3; // 0보다 클때 0.3~2.3 랜덤

		console.log('_calcProgress/ perPro = ', perPro);
		let per = origin;
		if (origin > 0) {
			const value = origin + perPro;
			if (value <= 100) {
				per = value;
			}
			else {
				per = 100;
			}
		}
		else {
			const value = this.lastProgress + zeroBasePercent; 
			if (value <= 100) {
				per = value;
			}
			else {
				per = 100;
			}
		}
		this.lastProgress = per;
		return per;
	}

	async _getResourceStatus(resourceIds ) {
		const url = this.baseUrl + '/get-resource-status';

    // get-resource-status does not require user authentication
		//if (!this.token) return undefined;

		try {
			let response = await axios.post(url,
				{
					resourceIds: resourceIds
				},
/*
				{
					headers: {
						Authorization: 'BEARER ' + this.token
					}
				}
*/
			);
			console.log('status / response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				return response.data.resourceStatus;
			}
		}
		catch (e) {
			console.log(e);
		}
		return undefined;	
	}

	async getResourceStatus(resourceIds) {
    return await this._getResourceStatus(resourceIds);
	}

	async getResources(resourceIds) {
		const url = this.baseUrl + '/get-resources';

    // get-resources is now changed to allow for unauthenticated call
		//if (!this.token) return undefined;

		try {
			let response = await axios.post(url,
				{
					resourceIds: resourceIds
				},
/*
				{
					headers: {
						Authorization: 'BEARER ' + this.token
					}
				}
*/
			);
			console.log('response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				return response.data.resources;
			}
		}
		catch (e) {
			console.log(e);
		}
		return undefined;
	}

	async createIdentity(
		category,
		auxIds,
		acl,
		attrs,
		dattrs,
		resources,
		updaterAppUrl,
		viewerAppUrl,
		isTemporary,
		accessNotifyPolicy,
		extensions) {

		const url = this.baseUrl + '/create-identity';

		if (!this.token) return undefined;

		try {
			let response = await axios.post(url,
				{
					category: category,
					auxIds: auxIds,
					acl: acl,
					attrs: attrs,
					dattrs: dattrs,
					resources: resources,
					updaterAppUrl: updaterAppUrl,
					viewerAppUrl: viewerAppUrl,
					isTemporary: isTemporary,
					accessNotifyPolicy: accessNotifyPolicy,
					extensions: extensions
				},
				{
					headers: {
						Authorization: 'BEARER ' + this.token
					}
				}
			);
			console.log('response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				return response.data.id;
			}
		}
		catch (e) {
			console.log(e);
		}
		return undefined;
	}

	async updateIdentity(identityId, updates) {
		const url = this.baseUrl + '/update-identity';

		if (!this.token) return undefined;

		try {
			let response = await axios.post(url,
				{
					identityId: identityId,
					updates: updates,
				},
				{
					headers: {
						Authorization: 'BEARER ' + this.token
					}
				}
			);
			console.log('response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				return true;
			}
		}
		catch (e) {
			console.log(e);
		}
		return false;
	}

	async getIdentities(identityIds) {
		const url = this.baseUrl + '/get-identities';

		try {
			let response = await axios.post(url,
				{
					identityIds: identityIds,
				},
				{
					headers: {
						Authorization: 'BEARER ' + this.token
					}
				}
			);
			console.log('response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				return response.data.identities;
			}
		}
		catch (e) {
			console.log(e);
		}
		return undefined;
	}

	async accessIdentity(identityId, accessParams) {
		const url = this.baseUrl + '/access-identity';

		try {
			let response = await axios.post(url,
				{
					identityId: identityId,
					accessParams: accessParams,
					returnValues: true
				}
			);
			console.log('response = ' + JSON.stringify(response.data));
			if (response.data) {
				if (response.data.result === 'OK') {
					return {
						result: 'OK',
						attrs: response.data.attrs,
						dattrs: response.data.dattrs,
						resources: response.data.resources,
					};
				}
				else {
					return {
						result: response.data.result,
					};
				}
			}
		}
		catch (e) {
			console.log(e);
		}
		return undefined;
	}

	async getSeqNum(seqName) {
		const url = this.baseUrl + '/get-seq-num';

		try {
			let response = await axios.post(url,
				{
					seqName: seqName
				}
			);
			console.log('response = ' + JSON.stringify(response.data));
			if (response.data && response.data.result === 'OK') {
				return response.data.seqNum;
			}
		}
		catch (e) {
			console.log(e);
		}
		return undefined;
	}
};

export default DipClient;
